import React from 'react';
import { Moon } from 'lucide-react';
import { Theme, Translations } from '../../i18n/translations';

interface ThemeSettingsProps {
  theme: Theme;
  onThemeChange: (theme: Theme) => void;
  t: Translations;
}

export const ThemeSettings: React.FC<ThemeSettingsProps> = ({
  theme,
  onThemeChange,
  t,
}) => {
  const themes: { value: Theme; label: string }[] = [
    { value: 'system', label: t.themeSystem },
    { value: 'light', label: t.themeLight },
    { value: 'dark', label: t.themeDark },
  ];

  return (
    <div className="bg-white dark:bg-gray-800 border-2 border-gray-300 dark:border-gray-600 p-4 mb-4">
      <h3 className="font-bold mb-3 flex items-center gap-2 text-gray-900 dark:text-white">
        <Moon className="w-4 h-4" />
        {t.theme}
      </h3>
      <p className="text-sm text-gray-600 dark:text-gray-400 mb-3">
        {t.themeDesc}
      </p>
      <div className="flex gap-2">
        {themes.map((item) => (
          <button
            key={item.value}
            onClick={() => onThemeChange(item.value)}
            className={`px-4 py-2 text-sm font-semibold border-2 ${
              theme === item.value
                ? 'bg-black text-white border-black dark:bg-white dark:text-black dark:border-white'
                : 'bg-white text-gray-700 border-gray-300 hover:bg-gray-100 dark:bg-gray-700 dark:text-gray-300 dark:border-gray-600 dark:hover:bg-gray-600'
            }`}
          >
            {item.label}
          </button>
        ))}
      </div>
    </div>
  );
};
